import { render, staticRenderFns } from "./Year.vue?vue&type=template&id=27e2a305"
import script from "./Year.vue?vue&type=script&setup=true&lang=js"
export * from "./Year.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../frontend.kantoor/app/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports